import { AuthState } from '@/core/store/features/auth/types';
import { DELETE, GET, PATCH, POST } from '@/lib/api/Methods';
import { TClinicPackages, TUserProfileDetails } from './user.types';
import { TSelectReason } from '@/components/layouts/landing/ManageProfile/profile-delete/select-reason/select-reason.validator';
import { Card, TPrescriptions } from '@/core/models';

export const getMe = () => GET<never, AuthState['user']>('/user/get-me');

export const getProfile = () => GET<never, TUserProfileDetails>('user/profile-details');

export const updateProfile = (data: FormData) => PATCH<FormData, TUserProfileDetails>('user/update-profile', data);

export const uploadProfileImage = (formData: FormData) =>
   POST<FormData, unknown>('/user/profile-image-upload', formData);

export const makeDeleteRequest = (data: TSelectReason) =>
   POST<TSelectReason, unknown>('/delete-profile/create-request', data);

export const getUserCardDetails = (id: string) => GET<never, Card>(`card/user/latest-card/${id}`);

export const getUserPreconscriptionDetails = (userId: string) =>
   GET<never, TPrescriptions[]>(`card/patient-referal-prescriptions/${userId}`);

export const emailChange = (token: string) =>
   POST<{ token: string }, TUserProfileDetails>('/user/reset-email-admin', { token });

export const deleteMedicalCertificateById = (id: string) =>
   DELETE<never, unknown>(`application/delete-medical-certificate/${id}`);

export const deleteSummerycareById = (id: string) => DELETE<never, unknown>(`application/delete-summery-care/${id}`);

export const clinicPackages = () => GET<never, TClinicPackages[]>('/user/clinic-packages');

export const clinicPackagesByClinicId = (id: string) =>
   GET<never, TClinicPackages[]>(`/user/clinic-packages-by-clinic-id/${id}`);

export const getpatientPreconscriptionDetails = () => GET<never, TPrescriptions[]>(`card/patient-user-prescriptions`);
